import { Component, OnInit, ViewChild, Inject, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { CommonService } from "../../../services";
import { UserInfoViewModel, StateModel } from "../../../models/account-ledger.model";
import { CheckOutService } from "../../../services/checkout.service";
import { GetEndUserAddressBookOutput } from "../../../models/check-out.model";
import { ApiResponse } from "../../../models/api-response.model";
import { ShoppingCartService } from "../../../services/shopping-cart.service";
import { Observable, Subject } from "rxjs";
import { PostcodeList, SuburbList } from "../../../models/account-delivery-address";
import { startWith, map, takeUntil } from "rxjs/operators";
import { DOCUMENT } from "@angular/common";
import { DeleteConfirmComponent } from "../../../popup-collection/delete-confirm/delete-confirm.component";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { MatDialog } from "@angular/material/dialog";

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-edit-end-user-address-book',
  templateUrl: './edit-end-user-address-book.component.html',
  styleUrls: ['./edit-end-user-address-book.component.css']
})
export class EditEndUserAddressBookComponent implements OnInit, OnDestroy {

  title: string;
  setFullWindow: boolean = false;
  hide: boolean = true;
  hideConfirm: boolean = true;
  adminChecked: boolean = false;
  purchaseChecked: boolean = false;
  userFormGroup: FormGroup;
  userInfo: UserInfoViewModel;
  stateList: string[];
  routeLast: string;
  endUserAddressBookOutput: GetEndUserAddressBookOutput;
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  loadContent: boolean = false;
  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  user_validation_messages: any = {
    "contactName": [
      { class: "contactNameValidate", message: "Please enter Contact Name" }
    ],
    "email": [
      { class: "emailValidate", message: "Please enter email" }
    ],
    "companyName": [
      { class: "companyNameValidate", message: "Please enter company name" }
    ],
    "address": [
      { class: "addressValidate", message: "Please enter address" }
    ],
    "suburb": [
      { class: "suburbValidate", message: "Please enter suburb" }
    ],
    "state": [
      { class: "stateValidate", message: "Please enter state" }
    ],
    "postcode": [
      { class: "postcodeValidate", message: "Please enter postcode" }
    ],
    "resellerEmail": [
      { class: "resellerEmailValidate", message: "Please enter reseller email" }
    ]
  }
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private checkOutService: CheckOutService,
    private shoppingCartService: ShoppingCartService,
    private activeRouter: ActivatedRoute,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.userFormGroup = this.formBuilder.group({
      salesType: new FormControl(""),
      contactName: new FormControl("", Validators.compose([Validators.required])),
      email: new FormControl("", this.commonService.emailValidatorRegex()),
      endUserCsn: new FormControl(""),
      companyName: new FormControl("", Validators.compose([Validators.required])),
      address: new FormControl("", Validators.compose([Validators.required])),
      address2: new FormControl(""),
      suburb: new FormControl("", Validators.compose([Validators.required])),
      state: new FormControl("", Validators.compose([Validators.required])),
      postcode: new FormControl("", Validators.compose([Validators.required])),
      phoneNo: new FormControl(""),
      endUserContract: new FormControl(""),
      ace: new FormControl(""),
      resellerCsn: new FormControl(""),
      serialNumber: new FormControl(""),
      resellerEmail: new FormControl(""),
      endUserId: new FormControl(""),
      country: new FormControl("")
    });
  }

  ngOnInit() {
    this.loadContent = false;
    this.activeRouter.url.subscribe(value => {
      this.routeLast = value[0].path;
      if (this.routeLast == "editenduseraddress") {
        this.title = "Edit End User";
        this.checkOutService.getEndUserAddressBookWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: GetEndUserAddressBookOutput) => {

          this.endUserAddressBookOutput = res;
          if (this.endUserAddressBookOutput) {
            this.userFormGroup.get("salesType").setValue(res.out_sales_type);
            this.userFormGroup.get("contactName").setValue(res.out_display_name);
            this.userFormGroup.get("email").setValue(res.out_email);
            this.userFormGroup.get("endUserCsn").setValue(res.out_display_name);
            this.userFormGroup.get("companyName").setValue(res.out_company_name);
            this.userFormGroup.get("address").setValue(res.out_address_1);
            this.userFormGroup.get("address2").setValue(res.out_address_2);
            this.userFormGroup.get("suburb").setValue(res.out_suburb);
            this.userFormGroup.get("state").setValue(res.out_state);
            this.userFormGroup.get("postcode").setValue(res.out_postcode);
            this.userFormGroup.get("phoneNo").setValue(res.out_phone);
            this.userFormGroup.get("endUserContract").setValue(res.out_agreement);
            this.userFormGroup.get("ace").setValue(res.out_agree_support);
            this.userFormGroup.get("resellerCsn").setValue(res.out_user_only_5);
            this.userFormGroup.get("serialNumber").setValue(res.out_user_only_11);
            this.userFormGroup.get("resellerEmail").setValue(res.out_user_only_20);
            this.userFormGroup.get("endUserId").setValue(res.out_eu_id);
            this.userFormGroup.get("country").setValue(res.out_country);
          } else {
            this.router.navigate(['../enduseraddress'], { relativeTo: this.activatedRoute.parent });
          }
          this.loadContent = true;
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      } else if (this.routeLast == "addenduser") {
        this.checkOutService.getEndUserAddressBookWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: GetEndUserAddressBookOutput) => {
          this.endUserAddressBookOutput = res;
          if (this.endUserAddressBookOutput) {
            this.userFormGroup.get("salesType").setValue(this.endUserAddressBookOutput.out_sales_type);
            this.title = "New End User";
            this.loadContent = true;
          } else {
            this.loadContent = true;
            this.router.navigate(['../enduseraddress'], { relativeTo: this.activatedRoute.parent });
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }
    });

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
      });
  }

  saveEndUser(): void {
    if (this.userFormGroup.valid) {
      let flag = false;
      if (this.userFormGroup.get("postcode").value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', "Please input valid postcode", "right", "error");
      }
      if (!flag) {
        this.loadContent = false;
        this.checkOutService.UpdateEndUserDetailAddress(JSON.stringify(this.userFormGroup.getRawValue())).subscribe((res: ApiResponse) => {
          if (res && res.status) {
            this.loadContent = true;
            this.commonService.implementToast(res.responseMessage, "Success");
            setTimeout(() => {
              //this.router.navigate(['../enduseraddress'], { relativeTo: this.activatedRoute.parent });
              this.router.navigateByUrl("/myAccount/enduseraddress?refresh=true");
            }, 1000);
          } else {
            this.commonService.implementToast(res.responseMessage, "Error");
            this.loadContent = true;
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }
    } else {
      this.isNotValidField("contactName", this.user_validation_messages.contactName);
      this.isNotValidField("email", this.user_validation_messages.email);
      this.isNotValidField("companyName", this.user_validation_messages.companyName);
      this.isNotValidField("address", this.user_validation_messages.address);
      this.isNotValidField("suburb", this.user_validation_messages.suburb);
      this.isNotValidField("state", this.user_validation_messages.state);
      this.isNotValidField("postcode", this.user_validation_messages.postcode);
    }
  }

  deleteEndUser(): void {
    const dialogRef = this.dialog.open(DeleteConfirmComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.checkOutService.DeleteEndUserDetail(this.userFormGroup.get("endUserId").value).subscribe((res: ApiResponse) => {
          this.loadContent = true;
          if (res.status) {
            this.commonService.implementToast('The End User Was Successfully Deleted', "Success")
            setTimeout(() => {
              this.router.navigateByUrl("/myAccount/enduseraddress?refresh=true");
            }, 1000);
          }
          else {
            this.commonService.implementToast(res.responseMessage, "Error")
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
            this.commonService.implementToast('Error occured', "Error");
          });
      }
    });
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('postcode').setValue(option.postcode);
    this.userFormGroup.get('state').setValue(option.state);
    this.userFormGroup.get('suburb').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('postcode').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('state').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('suburb').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('postcode').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('state').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('suburb').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
  
 
  startFilterSub(res: PostcodeList[]): void {
        this.filteredSub = res; 
  }

  startFilterPostcode(res: PostcodeList[]): void {   
    this.filteredPostCode = res;   
  }

  onInputSub(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "email") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    $(".page-contents").animate({ scrollLeft: -$("#levelOne").width() }, 400);
    this.router.navigate(['../enduseraddress'], { relativeTo: this.activatedRoute.parent });
  }
}
